var exports = {
  "container": "MediaTimeDisplay.module__container___emZnaz",
  "time": "MediaTimeDisplay.module__time___emZnaz",
  "separator": "MediaTimeDisplay.module__separator___emZnaz",
  "small": "MediaTimeDisplay.module__small___emZnaz",
  "medium": "MediaTimeDisplay.module__medium___emZnaz",
  "large": "MediaTimeDisplay.module__large___emZnaz",
  "compact": "MediaTimeDisplay.module__compact___emZnaz",
  "duration": "MediaTimeDisplay.module__duration___emZnaz",
};

__webpack_require__.r(module.exports = exports);
